(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-producto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psi-product')) {
    class PsiProduct extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-psi-variants]');
        try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (e) { this.variants = []; }
 
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-option-index]')) this.onOptionChange();
        });
 
        this.querySelectorAll('[data-psi-thumb]').forEach((b) =>
          b.addEventListener('click', () => this.showMedia(b.dataset.mediaId))
        );
 
        this.querySelectorAll('[data-psi-qty]').forEach((b) =>
          b.addEventListener('click', () => {
            const input = b.parentElement.querySelector('input[name="quantity"]');
            if (!input) return;
            const step = Number(input.step) || 1;
            const min = Number(input.min) || 1;
            const max = input.max ? Number(input.max) : Infinity;
            let val = (Number(input.value) || min) + (b.dataset.psiQty === '+' ? step : -step);
            input.value = Math.min(max, Math.max(min, val));
          })
        );
 
        const zoomDialog = this.querySelector('[data-psi-zoom-dialog]');
        this.querySelectorAll('[data-psi-zoom]').forEach((b) =>
          b.addEventListener('click', () => {
            if (!zoomDialog || !zoomDialog.showModal) return;
            const img = zoomDialog.querySelector('[data-psi-zoom-img]');
            img.src = b.dataset.psiZoom;
            img.alt = b.dataset.psiZoomAlt || '';
            zoomDialog.showModal();
          })
        );
 
        this.querySelectorAll('[data-psi-open]').forEach((b) =>
          b.addEventListener('click', () => {
            const d = document.getElementById(b.dataset.psiOpen);
            if (d && d.showModal) d.showModal();
          })
        );
        this.querySelectorAll('[data-psi-close]').forEach((b) =>
          b.addEventListener('click', () => b.closest('dialog').close())
        );
        this.querySelectorAll('dialog').forEach((d) =>
          d.addEventListener('click', (e) => { if (e.target === d) d.close(); })
        );
 
        // Tras enviar el formulario de presupuesto, reabrir el diálogo para mostrar el resultado
        this.querySelectorAll('[data-psi-quote-posted]').forEach((el) => {
          const d = el.closest('dialog');
          if (d && d.showModal && !d.open) d.showModal();
        });
 
        const current = this.variants.find((v) => String(v.id) === this.dataset.currentVariant);
        this.update(current, false);
      }
 
      selectedOptions() {
        const out = [];
        const count = Number(this.dataset.optionCount || 0);
        for (let i = 0; i < count; i++) {
          const el =
            this.querySelector(`select[data-option-index="${i}"]`) ||
            this.querySelector(`input[data-option-index="${i}"]:checked`);
          out.push(el ? el.value : null);
        }
        return out;
      }
 
      onOptionChange() {
        const sel = this.selectedOptions();
        sel.forEach((val, i) => {
          const lbl = this.querySelector(`[data-psi-option-label="${i}"]`);
          if (lbl) lbl.textContent = val;
        });
        const v = this.variants.find((x) => x.options.every((o, i) => o === sel[i]));
        this.update(v, true);
      }
 
      markAvailability() {
        const sel = this.selectedOptions();
        this.querySelectorAll('input[data-option-index]').forEach((input) => {
          const idx = Number(input.dataset.optionIndex);
          const ok = this.variants.some(
            (v) => v.available && v.options.every((o, i) => (i === idx ? o === input.value : o === sel[i]))
          );
          input.closest('.psi-pill')?.classList.toggle('is-unavailable', !ok);
        });
      }
 
      showMedia(id) {
        if (!id) return;
        const slide = this.querySelector(`.psi-gallery__slide[data-media-id="${id}"]`);
        if (!slide) return;
        this.querySelectorAll('.psi-gallery__slide').forEach((s) => s.classList.toggle('is-active', s === slide));
        this.querySelectorAll('[data-psi-thumb]').forEach((t) =>
          t.classList.toggle('is-active', t.dataset.mediaId === String(id))
        );
      }
 
      setAll(selector, fn) { this.querySelectorAll(selector).forEach(fn); }
 
      update(v, fromUser) {
        const zero = v && v.price === 0;
 
        this.setAll('input[name="id"]', (i) => { i.value = v ? v.id : ''; });
 
        // Precio
        this.setAll('[data-psi-price-wrap]', (el) => { el.hidden = !v || zero; });
        this.setAll('[data-psi-price-tax-wrap]', (el) => { el.hidden = !v || zero; });
        this.setAll('[data-psi-price-zero]', (el) => { el.hidden = !zero; });
        if (v) {
          this.setAll('[data-psi-price]', (el) => { el.innerHTML = v.price_html; });
          this.setAll('[data-psi-price-tax]', (el) => { el.innerHTML = v.price_tax_html; });
          this.setAll('[data-psi-compare]', (el) => { el.hidden = !v.compare_html; el.innerHTML = v.compare_html || ''; });
        }
 
        // Referencias
        const sku = v && v.sku ? v.sku : '';
        const barcode = v && v.barcode ? v.barcode : '';
        this.setAll('[data-psi-sku]', (el) => { el.textContent = sku; });
        this.setAll('[data-psi-sku-wrap]', (el) => { el.hidden = !sku; });
        this.setAll('[data-psi-barcode]', (el) => { el.textContent = barcode; });
        this.setAll('[data-psi-barcode-wrap]', (el) => { el.hidden = !barcode; });
        this.setAll('[data-psi-sku-inline]', (el) => { el.textContent = sku ? ` · Ref. ${sku}` : ''; });
 
        // Stock
        this.setAll('[data-psi-stock]', (el) => {
          let state = 'in';
          let text = el.dataset.textIn;
          const low = Number(el.dataset.low || 0);
          if (!v) { state = 'na'; text = el.dataset.textNa; }
          else if (v.qty === null) { if (!v.available) { state = 'out'; text = el.dataset.textOut; } }
          else if (v.qty > 0) {
            if (low > 0 && v.qty <= low) { state = 'low'; text = el.dataset.textLow.replace('[cantidad]', v.qty); }
          } else if (v.available) { state = 'back'; text = el.dataset.textBack; }
          else { state = 'out'; text = el.dataset.textOut; }
          el.className = `psi-stock psi-stock--${state}`;
          const t = el.querySelector('[data-psi-stock-text]');
          if (t) t.textContent = text;
        });
 
        // Botón de compra
        this.setAll('[data-psi-add]', (btn) => {
          let label = btn.dataset.labelAdd;
          let disabled = false;
          if (!v) { label = btn.dataset.labelNa; disabled = true; }
          else if (zero) { label = btn.dataset.labelConsult; disabled = true; }
          else if (!v.available) { label = btn.dataset.labelOut; disabled = true; }
          btn.disabled = disabled;
          btn.textContent = label;
        });
        this.setAll('[data-psi-dynamic]', (el) => { el.hidden = !v || zero || !v.available; });
 
        // Reglas de cantidad (pedido mínimo / múltiplos)
        if (v) {
          this.setAll('input[name="quantity"]', (q) => {
            q.min = v.q_min; q.step = v.q_step;
            if (v.q_max) q.max = v.q_max; else q.removeAttribute('max');
            if (Number(q.value) < v.q_min) q.value = v.q_min;
          });
        }
 
        // Presupuesto: producto + referencia + enlace
        if (v) {
          const base = this.dataset.quoteBase;
          const origin = window.location.origin;
          this.setAll('[data-psi-quote-product]', (el) => {
            el.value = `${base}${sku ? ' | Ref.: ' + sku : ''} | ${origin}${v.url}`;
          });
        }
 
        this.markAvailability();
 
        if (fromUser && v) {
          if (v.media_id) this.showMedia(v.media_id);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }
    customElements.define('psi-product', PsiProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
